/** Sol menünün bölüm şeridi — yalnızca dolu bölümler çip olarak çıkar. */
import { useTranslation } from 'react-i18next';
import { BarChart3, LayoutGrid, List, Star } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import type { MenuCategory } from './menuCategories';

const ICONS: Record<MenuCategory, typeof Star> = {
  all: LayoutGrid,
  favorites: Star,
  dashboards: BarChart3,
  screens: List,
};

export interface MenuCategoryBarProps {
  categories: MenuCategory[];
  value: MenuCategory;
  onChange: (c: MenuCategory) => void;
  counts: Partial<Record<MenuCategory, number>>;
}

export function MenuCategoryBar({ categories, value, onChange, counts }: MenuCategoryBarProps) {
  const { t } = useTranslation();
  // Tek seçenek varsa şerit bir şey anlatmıyor, yer kaplamasın.
  if (categories.length < 2) return null;

  return (
    <div role="tablist" aria-label={t('shell.category.label')} className="flex flex-wrap gap-1 px-2 pb-2">
      {categories.map((c) => {
        const Icon = ICONS[c];
        const active = c === value;
        const count = counts[c];
        return (
          <button
            key={c}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(c)}
            title={t(`shell.category.${c}`)}
            className={cn(
              'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs transition-colors',
              active
                ? 'border-brand-600 bg-brand-500/15 text-brand-700 dark:text-brand-400 font-medium'
                : 'border-border text-fg-muted hover:bg-bg-hover hover:text-fg',
            )}
          >
            <Icon className="h-3 w-3" />
            <span>{t(`shell.category.${c}`)}</span>
            {typeof count === 'number' && count > 0 ? <span className="text-fg-subtle">{count}</span> : null}
          </button>
        );
      })}
    </div>
  );
}
